import { render } from "./LojaPainel.vue?vue&type=template&id=33116f14&scoped=true"
import script from "./LojaPainel.vue?vue&type=script&lang=js"
export * from "./LojaPainel.vue?vue&type=script&lang=js"

import "./LojaPainel.vue?vue&type=style&index=0&id=33116f14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33116f14"]])

export default __exports__